import { render, staticRenderFns } from "./ManageMemberUsedBenefits.vue?vue&type=template&id=00affd20&"
import script from "./ManageMemberUsedBenefits.vue?vue&type=script&lang=js&"
export * from "./ManageMemberUsedBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports